import React, { useEffect, useState, useRef, cloneElement, createElement, Component } from 'react';
import { cn } from '@/lib/utils';
import { useMotionValue, useTransform, animate } from 'framer-motion';
import { CheckCircle2, Star, Heart, CreditCard, Users, Ticket, ArrowRight, MessageCircle, X, ThumbsUp, GraduationCap, Zap, ShieldCheck, Flower2, Leaf, Sparkles, Medal } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';
// --- Types ---
declare global {
  interface Window {
    fbq: any;
    _fbq: any;
  }
}
// --- Constants & Data ---
const CHECKOUT_URL = 'https://booknova.store/cart/48530262130937:1';
const MAIN_IMAGE = 'https://cdn.magicpatterns.com/uploads/npQgkL51ifKiAYU7NpRrzU/COSMETICA_VIVA_PNG.png';
const BONUSES = [{
  id: 1,
  img: 'https://cdn.magicpatterns.com/uploads/gupmjWjTaHKzvZynE789Sc/BONO_1_LIBRO.png',
  title: 'Cabello Vivo',
  description: 'Fórmulas naturales para un cabello fuerte, brillante y saludable desde la raíz.'
}, {
  id: 2,
  img: 'https://cdn.magicpatterns.com/uploads/xmxtvNAwGKzxKNY9ifZECj/BONO_2_LIBRO.png',
  title: 'Maquillaje Vivo',
  description: 'Crea tu propio maquillaje mineral y natural libre de tóxicos y químicos pesados.'
}, {
  id: 3,
  img: 'https://cdn.magicpatterns.com/uploads/edw9sA2n6EFLQRzRR6xmdC/BONO_3_LIBRO.png',
  title: 'Shampoo Vivo',
  description: 'Domina el arte del shampoo sólido y líquido adaptado a cada tipo de necesidad.'
}, {
  id: 4,
  img: 'https://cdn.magicpatterns.com/uploads/b47Fkrfh6L5z3dXV1py2kg/BONO_4_LIBRO.png',
  title: 'Perfumes Capilares',
  description: 'Fragancias botánicas que refrescan, cuidan y embellecen tu cabello todo el día.'
}, {
  id: 5,
  img: 'https://cdn.magicpatterns.com/uploads/kJTxrUCwgBoc3JNdXJjDDa/BONO_5_LIBRO.png',
  title: 'Protección Natural',
  description: 'Elabora tus propios protectores solares y pastas dentales 100% biodegradables.'
}, {
  id: 6,
  img: 'https://cdn.magicpatterns.com/uploads/vs3CEyEMj6qzDcdTCyNe5f/BONO_6_LIBRO.png',
  title: 'Alivio Natural',
  description: 'Ungüentos y pomadas artesanales para calmar dolores y cuidar la piel de tu familia.'
}, {
  id: 7,
  img: 'https://cdn.magicpatterns.com/uploads/hsHYxByebbeN3LRkzf3GYC/BONO_7_LIBRO.png',
  title: 'Mirada Viva',
  description: 'Fortalece y embellece tus pestañas y cejas con sérums botánicos de alto impacto.'
}, {
  id: 8,
  img: 'https://cdn.magicpatterns.com/uploads/2KMF1pLfoas2dhC79MqwQp/BONO_8_LIBRO.png',
  title: 'Modelado Capilar',
  description: 'Geles y cremas de peinar naturales para definir tus rizos y controlar el frizz.'
}];
const INITIAL_TESTIMONIALS = [{
  id: 1,
  name: 'Carmen G.',
  city: 'Rosario',
  text: 'Tengo 57 años y nunca había preparado nada cosmético. Empecé con la crema de noche y me encantó el resultado. Me dejó la piel suave y sin sensación grasosa. es mas facil de lo que pensaba',
  rating: 5,
  likes: 12,
  date: 'hace 2 horas',
  avatar: 'https://cdn.magicpatterns.com/uploads/dkg7hcEgmf515qUh6TPz3Z/image.png'
}, {
  id: 2,
  name: 'Mariela',
  city: 'Córdoba',
  text: 'estaba re perdida con los ingredientes pero la guia te explica todo paso a paso. ya tengo mis primeros balsamos listos para regalar en navidad!',
  rating: 5,
  likes: 8,
  date: 'hace 5 horas',
  avatar: 'https://cdn.magicpatterns.com/uploads/sdoqWXDaGMnsENyXGeSq86/image.png'
}, {
  id: 3,
  name: 'maria mercedes',
  city: 'Buenos Aires',
  text: 'Me encanto el enfoque natural. Al principio dudaba xq no sabia nada de quimica pero es super amigable. 100% recomendado',
  rating: 4,
  likes: 15,
  date: 'hace 1 día',
  avatar: 'https://cdn.magicpatterns.com/uploads/nUE7i5ETko2duvdpTJT47c/image.png'
}, {
  id: 4,
  name: 'Pato',
  city: 'Mendoza',
  text: 'la verdad q x el precio es un regalo. los bonos estan buenisimos tmb. el de shampoo me cambio el pelo mal',
  rating: 5,
  likes: 21,
  date: 'hace 2 días',
  avatar: 'https://cdn.magicpatterns.com/uploads/kWofqSLbVTbMnCwQq668SF/image.png'
}, {
  id: 5,
  name: 'Vane',
  city: 'Salta',
  text: 'ya empece a vender mis propios tonicos a mis amigas y estan chochas. una oportunidad de oro para arrancar algo propio',
  rating: 5,
  likes: 34,
  date: 'hace 3 días',
  avatar: 'https://cdn.magicpatterns.com/uploads/mTKorJuksAvzwCUDpa41vU/image.png'
}];
const ARG_CITIES = ['CABA', 'Córdoba', 'Rosario', 'Mendoza', 'Salta', 'Tucumán', 'La Plata', 'Mar del Plata', 'Neuquén', 'Posadas'];
const ARG_NAMES = ['María', 'Florencia', 'Agustina', 'Lucía', 'Camila', 'Valentina', 'Martina', 'Paula', 'Silvia', 'Gabriela'];
// --- Components ---
const Button = ({
  children,
  className = '',
  onClick,
  showShine = false
}: {
  children: React.ReactNode;
  className?: string;
  onClick?: () => void;
  showShine?: boolean;
}) => <button onClick={onClick || (() => window.location.href = CHECKOUT_URL)} className={`w-full py-4 px-6 rounded-xl font-bold text-lg transition-all transform hover:scale-105 active:scale-95 shadow-lg flex items-center justify-center gap-2 relative overflow-hidden ${className}`} data-id="element-0">
    {showShine && <motion.div initial={{
    x: '-150%'
  }} animate={{
    x: '150%'
  }} transition={{
    repeat: Infinity,
    duration: 2.5,
    ease: 'linear',
    repeatDelay: 3
  }} className="absolute inset-0 w-full h-full bg-gradient-to-r from-transparent via-white/30 to-transparent skew-x-[-25deg] pointer-events-none" data-id="element-1" />}
    <span className="relative z-10 flex items-center justify-center gap-2" data-id="element-2">
      {children}
    </span>
  </button>;
const Counter = ({
  target,
  duration
}: {
  target: number;
  duration: number;
}) => {
  const count = useMotionValue(0);
  const rounded = useTransform(count, latest => {
    const val = Math.round(latest);
    return val >= 1000 ? `+${val.toLocaleString('de-DE')}` : `+${val}`;
  });
  useEffect(() => {
    const controls = animate(count, target, {
      duration
    });
    return controls.stop;
  }, [count, target, duration]);
  return <motion.span data-id="element-3">{rounded}</motion.span>;
};
const Section = ({
  children,
  className = ''
}: {
  children: React.ReactNode;
  className?: string;
}) => <section className={cn(`py-12 px-6 max-w-4xl mx-auto ${className}`, 'pt-[9px] pb-[9px]', 'pt-[0px] pb-[0px] mt-[0px] mb-[0px]')} data-id="element-4">
    {children}
  </section>;
export function App() {
  const [isBonusPaused, setIsBonusPaused] = useState(false);
  const [coupons, setCoupons] = useState(13);
  const [viewers, setViewers] = useState(48);
  const [purchaseNotify, setPurchaseNotify] = useState<{
    name: string;
    city: string;
  } | null>(null);
  const [comments, setComments] = useState(INITIAL_TESTIMONIALS);
  const [studentCount, setStudentCount] = useState(1101);
  const [newComment, setNewComment] = useState('');
  const [newRating, setNewRating] = useState(5);
  const [showSuccessModal, setShowSuccessModal] = useState(false);
  const [visibleComments, setVisibleComments] = useState(5);
  const purchaseSectionRef = useRef<HTMLDivElement>(null);
  useEffect(() => {
    // --- Meta Pixel Code ---
    const pixelId = '2633544103706749';
    if (!window.fbq) {
      !function (f, b, e, v, n, t, s) {
        if (f.fbq) return;
        n = f.fbq = function () {
          n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
        };
        if (!f._fbq) f._fbq = n;
        n.push = n;
        n.loaded = !0;
        n.version = '2.0';
        n.queue = [];
        t = b.createElement(e);
        t.async = !0;
        t.src = v;
        s = b.getElementsByTagName(e)[0];
        if (s && s.parentNode) {
          s.parentNode.insertBefore(t, s);
        } else {
          ;
          (b.head || b.body || b.documentElement).appendChild(t);
        }
      }(window, document, 'script', 'https://connect.facebook.net/en_US/fbevents.js');
      window.fbq('init', pixelId);
    }
    window.fbq('track', 'PageView');
    // --- End Meta Pixel Code ---
    const couponInterval = setInterval(() => {
      setCoupons(prev => prev > 2 ? prev - 1 : prev);
    }, 45000);
    const viewerInterval = setInterval(() => {
      setViewers(Math.floor(Math.random() * (55 - 35 + 1)) + 35);
    }, 10000);
    const notifyInterval = setInterval(() => {
      const name = ARG_NAMES[Math.floor(Math.random() * ARG_NAMES.length)];
      const city = ARG_CITIES[Math.floor(Math.random() * ARG_CITIES.length)];
      setPurchaseNotify({
        name,
        city
      });
      setTimeout(() => setPurchaseNotify(null), 5000);
    }, 15000);
    const studentInterval = setInterval(() => {
      setStudentCount(prev => prev + 1);
    }, 30000);
    return () => {
      clearInterval(couponInterval);
      clearInterval(viewerInterval);
      clearInterval(notifyInterval);
      clearInterval(studentInterval);
    };
  }, []);
  const scrollToPurchase = () => {
    purchaseSectionRef.current?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  const handlePostComment = () => {
    if (!newComment.trim()) return;
    const comment = {
      id: Date.now(),
      name: 'Usuario',
      city: 'Argentina',
      text: newComment,
      rating: newRating,
      likes: 0,
      date: 'ahora mismo'
    };
    setComments([comment, ...comments]);
    setNewComment('');
    setShowSuccessModal(true);
  };
  const today = new Date().toLocaleDateString('es-AR', {
    day: 'numeric',
    month: 'long',
    year: 'numeric'
  });
  return <div className="min-h-screen bg-[#FDF2F2] text-slate-800 overflow-x-hidden" data-id="element-5">
      {/* Meta Pixel Noscript */}
      <noscript data-id="element-6">
        <img height="1" width="1" style={{
        display: 'none'
      }} src="https://www.facebook.com/tr?id=2633544103706749&ev=PageView&noscript=1" alt="" data-id="element-7" />
      </noscript>

      {/* Trust Banner */}
      <div className="bg-white/40 border-b border-pink-100 py-1.5" data-id="element-8">
        <div className="max-w-4xl mx-auto px-4 flex flex-nowrap whitespace-nowrap text-[7px] md:text-[9px] font-semibold uppercase tracking-[0.2em] text-[#9D4D60] items-center justify-center md:gap-6 gap-[2px]" data-id="element-9">
          <div className="flex items-center gap-1" data-id="element-10">
            <GraduationCap size={10} className="text-[#D4AF37]" data-id="element-11" />
            <span data-id="element-12">
              <Counter target={1000} duration={5} data-id="element-13" /> Alumnos
            </span>
          </div>

          <Flower2 size={8} className="text-[#D4AF37] opacity-40" data-id="element-14" />

          <div className="flex items-center gap-1" data-id="element-15">
            <Zap size={10} className="text-[#D4AF37]" data-id="element-16" />
            <span data-id="element-17">Acceso Inmediato</span>
          </div>

          <Flower2 size={8} className="text-[#D4AF37] opacity-40" data-id="element-18" />

          <div className="flex items-center gap-1" data-id="element-19">
            <ShieldCheck size={10} className="text-[#D4AF37]" data-id="element-20" />
            <span data-id="element-21">Garantía 7 Días</span>
          </div>
        </div>
      </div>

      {/* Header */}

      {/* Validity Banner */}

      {/* Hero Section */}
      <Section className="text-center pt-12 pb-8" data-id="element-22">
        <div className="pt-[7px] pb-[7px] mt-[3px] mb-[3px]" data-id="element-23">
          <h1 className="text-xs md:text-sm font-bold tracking-[0.4em] mb-2 text-[#9D4D60] opacity-80" data-id="element-24">
            BIENVENIDA A
          </h1>
          <div className="relative inline-block" data-id="element-25">
            <span className="text-3xl md:text-5xl font-serif font-bold tracking-tight bg-gradient-to-r from-[#B76E79] via-[#E1B1B9] to-[#D4AF37] bg-clip-text text-transparent animate-pulse" data-id="element-26">
              COSMÉTICA VIVA
            </span>
            <div className="absolute -top-2 -right-4 text-[#D4AF37] animate-bounce" data-id="element-27">
              ✨
            </div>
            <div className="absolute -bottom-1 -left-2 text-[#D4AF37] animate-pulse delay-700" data-id="element-28">
              ✨
            </div>
          </div>
        </div>

        <div className="flex items-center justify-center opacity-60 pt-[0px] pb-[0px] mt-[9px] mb-[9px] gap-[16px]" data-id="element-29">
          <div className="h-[1px] w-8 bg-[#2D5A27]" data-id="element-30"></div>
          <span className="text-[10px] uppercase tracking-[0.3em] text-[#2D5A27] font-semibold" data-id="element-31">
            Tu momento es ahora
          </span>
          <div className="h-[1px] w-8 bg-[#2D5A27]" data-id="element-32"></div>
        </div>
        <h2 className="text-xl md:text-2xl font-serif italic text-[#2D5A27] leading-relaxed max-w-xl mx-auto pt-[0px] pb-[0px] mt-[0px] mb-[0px]" data-id="element-33">
          ¿Hace cuánto tiempo sentís ganas de empezar algo para vos?
        </h2>

        <div className="mb-6 cursor-pointer relative max-w-md mx-auto group" onClick={scrollToPurchase} data-id="element-34">
          {/* Subtle Floral Decorations */}
          <div className="absolute inset-0 pointer-events-none z-0" data-id="element-35">
            <motion.div animate={{
            y: [0, -15, 0],
            rotate: [0, 10, 0],
            opacity: [0.3, 0.6, 0.3]
          }} transition={{
            duration: 5,
            repeat: Infinity,
            ease: 'easeInOut'
          }} className="absolute -top-6 -left-4 text-[#B76E79]" data-id="element-36">
              <Flower2 size={28} strokeWidth={1.5} data-id="element-37" />
            </motion.div>

            <motion.div animate={{
            y: [0, 15, 0],
            rotate: [0, -15, 0],
            opacity: [0.2, 0.5, 0.2]
          }} transition={{
            duration: 6,
            repeat: Infinity,
            ease: 'easeInOut',
            delay: 1
          }} className="absolute top-1/4 -right-6 text-[#2D5A27]" data-id="element-38">
              <Leaf size={24} strokeWidth={1.5} data-id="element-39" />
            </motion.div>

            <motion.div animate={{
            scale: [1, 1.2, 1],
            opacity: [0.2, 0.4, 0.2]
          }} transition={{
            duration: 4,
            repeat: Infinity,
            ease: 'easeInOut',
            delay: 0.5
          }} className="absolute bottom-1/4 -left-8 text-[#D4AF37]" data-id="element-40">
              <Sparkles size={20} data-id="element-41" />
            </motion.div>

            <motion.div animate={{
            y: [0, -10, 0],
            rotate: [0, 20, 0],
            opacity: [0.3, 0.6, 0.3]
          }} transition={{
            duration: 7,
            repeat: Infinity,
            ease: 'easeInOut',
            delay: 2
          }} className="absolute -bottom-4 right-4 text-[#E1B1B9]" data-id="element-42">
              <Flower2 size={22} strokeWidth={1.5} data-id="element-43" />
            </motion.div>

            <motion.div animate={{
            rotate: [0, 10, 0],
            x: [0, 5, 0]
          }} transition={{
            duration: 8,
            repeat: Infinity,
            ease: 'easeInOut'
          }} className="absolute bottom-1/2 -right-4 text-[#2D5A27] opacity-20" data-id="element-44">
              <Leaf size={18} strokeWidth={1} data-id="element-45" />
            </motion.div>
          </div>

          <motion.img initial={{
          y: 0
        }} animate={{
          y: [0, -12, 0]
        }} transition={{
          duration: 5,
          repeat: Infinity,
          ease: 'easeInOut'
        }} src={MAIN_IMAGE} alt="Cosmética Viva Libro" className="w-full relative z-10 hover:scale-[1.05] transition-all duration-500 drop-shadow-[0_25px_45px_rgba(183,110,121,0.25)] pt-[0px] pb-[0px] mt-[0px] mb-[0px]" data-id="element-46" />
        </div>

        <div className="max-w-xl mx-auto mb-10" data-id="element-47">
          <p className="text-[10px] md:text-[12px] font-medium text-[#2D5A27] uppercase tracking-[0.35em] leading-relaxed opacity-95" data-id="element-48">
            Transformá{' '}
            <span className="text-[#9D4D60] font-black" data-id="element-49">
              ingredientes naturales
            </span>{' '}
            en productos que <br data-id="element-50" />
            <span className="text-[#D4AF37] font-black italic" data-id="element-51">
              cuidan tu piel
            </span>{' '}
            y despiertan tu{' '}
            <span className="text-[#9D4D60] font-black" data-id="element-52">creatividad</span>.
          </p>
        </div>
      </Section>

      {/* Problem Section with Comparison Table */}
      <Section className="my-16" data-id="element-53">
        <div className="text-center mb-10" data-id="element-54">
          <p className="font-bold text-red-500/80 uppercase tracking-[0.2em] text-xs mb-3" data-id="element-55">
            El desafío de empezar sola
          </p>
        </div>

        <div className="grid md:grid-cols-2 gap-6 max-w-3xl mx-auto" data-id="element-56">
          {/* Cons Column */}
          <div className="bg-red-50/40 border border-red-100 rounded-[2rem] p-8 space-y-6 relative overflow-hidden group" data-id="element-57">
            <div className="absolute top-0 right-0 p-4 opacity-5 group-hover:opacity-10 transition-opacity" data-id="element-58">
              <X size={80} className="text-red-500" data-id="element-59" />
            </div>
            <h4 className="font-serif text-xl text-red-700 font-bold flex items-center gap-2" data-id="element-60">
              <div className="w-8 h-8 rounded-full bg-red-100 flex items-center justify-center" data-id="element-61">
                <X size={16} className="text-red-500" data-id="element-62" />
              </div>
              Sin una guía clara
            </h4>
            <ul className="space-y-4 text-sm md:text-base text-red-900/70" data-id="element-63">
              <li className="flex items-start gap-3" data-id="element-64">
                <span className="mt-1.5 w-1.5 h-1.5 rounded-full bg-red-300 shrink-0" data-id="element-65" />
                Recetas incompletas y confusas de internet.
              </li>
              <li className="flex items-start gap-3" data-id="element-66">
                <span className="mt-1.5 w-1.5 h-1.5 rounded-full bg-red-300 shrink-0" data-id="element-67" />
                Videos contradictorios que te generan dudas.
              </li>
              <li className="flex items-start gap-3" data-id="element-68">
                <span className="mt-1.5 w-1.5 h-1.5 rounded-full bg-red-300 shrink-0" data-id="element-69" />
                Ingredientes que no conocés ni sabés usar.
              </li>
              <li className="flex items-start gap-3" data-id="element-70">
                <span className="mt-1.5 w-1.5 h-1.5 rounded-full bg-red-300 shrink-0" data-id="element-71" />
                Cantidades confusas que arruinan tus mezclas.
              </li>
            </ul>
          </div>

          {/* Pros Column */}
          <div className="bg-[#2D5A27]/5 border border-[#2D5A27]/10 rounded-[2rem] p-8 space-y-6 relative overflow-hidden group shadow-sm" data-id="element-72">
            <div className="absolute top-0 right-0 p-4 opacity-5 group-hover:opacity-10 transition-opacity" data-id="element-73">
              <Leaf size={80} className="text-[#2D5A27]" data-id="element-74" />
            </div>
            <h4 className="font-serif text-xl text-[#2D5A27] font-bold flex items-center gap-2" data-id="element-75">
              <div className="w-8 h-8 rounded-full bg-[#2D5A27]/10 flex items-center justify-center" data-id="element-76">
                <CheckCircle2 size={16} className="text-[#2D5A27]" data-id="element-77" />
              </div>
              Con Cosmética Viva
            </h4>
            <ul className="space-y-4 text-sm md:text-base text-[#2D5A27]/80" data-id="element-78">
              <li className="flex items-start gap-3" data-id="element-79">
                <Leaf size={14} className="mt-1 text-[#D4AF37] shrink-0" data-id="element-80" />
                Guía digital completa, simple y organizada.
              </li>
              <li className="flex items-start gap-3" data-id="element-81">
                <Leaf size={14} className="mt-1 text-[#D4AF37] shrink-0" data-id="element-82" />
                Paso a paso detallado para cada producto.
              </li>
              <li className="flex items-start gap-3" data-id="element-83">
                <Leaf size={14} className="mt-1 text-[#D4AF37] shrink-0" data-id="element-84" />
                Fundamentos reales sobre ingredientes.
              </li>
              <li className="flex items-start gap-3" data-id="element-85">
                <Leaf size={14} className="mt-1 text-[#D4AF37] shrink-0" data-id="element-86" />
                Confianza total al crear tus propias fórmulas.
              </li>
            </ul>
          </div>
        </div>
      </Section>

      {/* Solution Section */}
      <Section className="relative overflow-hidden" data-id="element-87">
        {/* Subtle Background Decoration */}
        <div className="absolute top-0 right-0 opacity-5 pointer-events-none -mr-20 -mt-20" data-id="element-88">
          <Flower2 size={300} className="text-[#B76E79]" data-id="element-89" />
        </div>

        <div className="text-center mb-16 relative z-10" data-id="element-90">
          <h3 className="text-3xl md:text-4xl font-serif font-bold text-[#2D5A27] mb-6 leading-tight pt-[14px] pb-[14px]" data-id="element-91">
            Cosmética Viva es una <br className="hidden md:block" data-id="element-92" />
            <span className="bg-gradient-to-r from-[#B76E79] to-[#D4AF37] bg-clip-text text-transparent" data-id="element-93">
              guía digital completa
            </span>
          </h3>
          <div className="w-24 h-[1px] bg-[#D4AF37]/30 mx-auto mb-6" data-id="element-94"></div>
          <p className="text-lg md:text-xl text-slate-600 max-w-2xl mx-auto italic font-serif pt-[0px] pb-[0px] mt-[0px] mb-[0px]" data-id="element-95">
            "Te enseña a elaborar cosmética natural de forma simple,{' '}
            <br className="hidden md:block" data-id="element-96" />
            práctica y profundamente organizada."
          </p>
        </div>

        <div className="grid md:grid-cols-2 gap-12 mb-16 relative z-10" data-id="element-97">
          <div className="bg-white/60 backdrop-blur-sm p-8 md:p-10 rounded-[2.5rem] shadow-xl shadow-pink-100/20 border border-pink-50 relative group" data-id="element-98">
            <div className="absolute -top-4 -left-4 bg-[#D4AF37] text-white p-3 rounded-2xl shadow-lg transform -rotate-12 group-hover:rotate-0 transition-transform duration-500" data-id="element-99">
              <Sparkles size={24} data-id="element-100" />
            </div>
            <h4 className="font-serif italic text-[#2D5A27] mb-8 text-2xl border-b border-[#2D5A27]/10 pb-4" data-id="element-101">
              ¿Qué vas a aprender?
            </h4>
            <ul className="grid grid-cols-1 gap-4" data-id="element-102">
              {['Cremas faciales y corporales', 'Sérums naturales', 'Tónicos faciales', 'Exfoliantes', 'Mascarillas', 'Bálsamos labiales', 'Perfumes naturales', 'Desodorantes naturales', 'Aceites corporales', 'Fórmulas antiedad', 'Maquillaje Natural', 'Protectores Solares', 'Sérums y Máscara de Pestañas'].map((item, i) => <li key={i} className="flex items-center gap-3 text-slate-700 group/item" data-id="element-103">
                  <div className="w-6 h-6 rounded-full bg-[#2D5A27]/5 flex items-center justify-center group-hover/item:bg-[#2D5A27]/10 transition-colors" data-id="element-104">
                    <Leaf size={12} className="text-[#2D5A27]" data-id="element-105" />
                  </div>
                  <span className="text-sm md:text-base font-medium tracking-wide" data-id="element-106">
                    {item}
                  </span>
                </li>)}
            </ul>
            <div className="mt-8 pt-6 border-t border-[#D4AF37]/10" data-id="element-107">
              <p className="text-[#D4AF37] font-bold tracking-widest uppercase text-xs flex items-center gap-2" data-id="element-108">
                <Sparkles size={14} data-id="element-109" /> Y mucho más por descubrir
              </p>
            </div>
          </div>

          <div className="flex flex-col justify-center space-y-8" data-id="element-110">
            <div className="space-y-6" data-id="element-111">
              {[{
              title: 'Sin experiencia previa',
              text: 'Aunque nunca hayas hecho una crema en tu vida.'
            }, {
              title: 'Paso a paso real',
              text: 'Aunque no tengas conocimientos de ingredientes o Formulación.'
            }, {
              title: 'Tu propio ritmo',
              text: 'Acceso de por vida para que aprendas cuando vos quieras.'
            }].map((item, i) => <div key={i} className="flex gap-5 items-start group" data-id="element-112">
                  <div className="w-12 h-12 rounded-2xl bg-white shadow-md flex items-center justify-center shrink-0 group-hover:scale-110 transition-transform duration-300 border border-pink-50" data-id="element-113">
                    <Heart size={20} className="text-[#9D4D60]" data-id="element-114" />
                  </div>
                  <div data-id="element-115">
                    <h5 className="font-bold text-[#2D5A27] text-lg mb-1" data-id="element-116">
                      {item.title}
                    </h5>
                    <p className="text-slate-500 leading-relaxed text-sm md:text-base" data-id="element-117">
                      {item.text}
                    </p>
                  </div>
                </div>)}
            </div>
          </div>
        </div>

        <div className="max-w-md mx-auto relative z-10" data-id="element-118">
          <Button showShine className="bg-gradient-to-r from-[#B76E79] to-[#9D4D60] text-white hover:shadow-[0_10px_30px_rgba(157,77,96,0.3)] py-6 text-xl tracking-widest uppercase" data-id="element-119">
            QUIERO EMPEZAR HOY <ArrowRight className="ml-2" data-id="element-120" />
          </Button>
          <p className="text-center mt-4 text-[10px] uppercase tracking-[0.2em] text-slate-400 font-bold" data-id="element-121">
            Acceso inmediato tras la compra
          </p>
        </div>
      </Section>

      {/* Methodology Section */}
      <Section className="my-20 relative" data-id="element-122">
        {/* Decorative Background Elements */}
        <div className="absolute top-1/2 left-0 -translate-y-1/2 -ml-12 opacity-10 pointer-events-none" data-id="element-123">
          <Leaf size={200} className="text-[#2D5A27] -rotate-45" data-id="element-124" />
        </div>

        <div className="max-w-3xl mx-auto text-center mb-12 relative z-10" data-id="element-125">
          <h3 className="text-3xl md:text-4xl font-serif font-bold text-[#2D5A27] mb-6" data-id="element-126">
            No son solo <span className="italic text-[#9D4D60]" data-id="element-127">recetas</span>
          </h3>
          <p className="text-slate-600 leading-relaxed max-w-xl mx-auto font-medium" data-id="element-128">
            La mayoría intenta copiar fórmulas sin entender el porqué.
            <span className="text-[#9D4D60]" data-id="element-129"> Cosmética Viva </span> te da los
            fundamentos para que crees con total libertad y seguridad.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-4 relative z-10" data-id="element-130">
          {[{
          title: 'Fundamentos Reales',
          text: 'Introducción a la cosmética natural y formulación consciente.'
        }, {
          title: 'Materia Prima',
          text: 'Ingredientes naturales y cómo utilizarlos correctamente.'
        }, {
          title: 'Seguridad Total',
          text: 'Conservación y seguridad de tus productos elaborados.'
        }, {
          title: 'Rostro y Cuerpo',
          text: 'Elaboración profesional de productos para piel y cuerpo.'
        }, {
          title: 'Bienestar Holístico',
          text: 'Aromaterapia y perfumes naturales con intención.'
        }, {
          title: 'Recetario Maestro',
          text: 'Un completo recetario con decenas de fórmulas listas.'
        }].map((item, i) => <div key={i} className="group bg-white/40 backdrop-blur-sm p-6 rounded-3xl border border-pink-100/50 hover:border-[#D4AF37]/30 transition-all duration-500 hover:shadow-xl hover:shadow-pink-100/20 flex gap-4 items-start" data-id="element-131">
              <div className="w-10 h-10 rounded-2xl bg-[#2D5A27]/5 flex items-center justify-center shrink-0 group-hover:bg-[#2D5A27] group-hover:text-white transition-colors duration-500" data-id="element-132">
                <Leaf size={18} data-id="element-133" />
              </div>
              <div data-id="element-134">
                <h4 className="font-bold text-[#2D5A27] text-sm md:text-base mb-1 uppercase tracking-wider" data-id="element-135">
                  {item.title}
                </h4>
                <p className="text-slate-500 text-xs md:text-sm leading-relaxed" data-id="element-136">
                  {item.text}
                </p>
              </div>
            </div>)}

          {/* Final Accent Card */}
          <div className="md:col-span-2 bg-gradient-to-r from-[#2D5A27] to-[#1a3a18] p-6 rounded-3xl text-white flex items-center justify-between group overflow-hidden relative" data-id="element-137">
            <div className="absolute top-0 right-0 opacity-10 group-hover:scale-110 transition-transform duration-700" data-id="element-138">
              <Flower2 size={120} data-id="element-139" />
            </div>
            <div className="relative z-10" data-id="element-140">
              <p className="font-serif italic text-lg md:text-xl" data-id="element-141">
                "Aprendé a formular, no solo a mezclar."
              </p>
            </div>
            <Sparkles className="text-[#D4AF37] relative z-10 animate-pulse" data-id="element-142" />
          </div>
        </div>
      </Section>

      {/* Bonus Section - Auto-scrolling Ribbon */}
      <section id="bonos" className="py-24 bg-white overflow-hidden relative pt-[49px] pb-[49px]" data-id="element-143">
        {/* Subtle background texture */}
        <div className="absolute inset-0 opacity-[0.03] pointer-events-none" data-id="element-144">
          <div className="absolute top-0 left-0 transform -translate-x-1/2 -translate-y-1/2" data-id="element-145">
            <Flower2 size={400} className="text-[#B76E79]" data-id="element-146" />
          </div>
        </div>

        <div className="text-center px-6 relative z-10 pt-[0px] pb-[0px] mt-[0px] mb-[0px]" data-id="element-147">
          <span className="text-[10px] uppercase tracking-[0.5em] text-[#9D4D60] font-bold mb-4 block" data-id="element-148">
            Regalos por tu Confianza
          </span>
          <h3 className="text-4xl md:text-6xl font-serif font-bold text-[#2D5A27] mb-6 uppercase tracking-tight" data-id="element-149">
            8 Bonos{' '}
            <span className="italic text-[#D4AF37] font-light" data-id="element-150">Exclusivos</span>
          </h3>
          <div className="inline-flex items-center gap-3 bg-[#FDF2F2] px-6 py-2 rounded-full border border-pink-100" data-id="element-151">
            <Sparkles size={16} className="text-[#D4AF37] animate-pulse" data-id="element-152" />
            <p className="text-sm md:text-base text-[#9D4D60] font-bold uppercase tracking-widest" data-id="element-153">
              Gratis solo por hoy
            </p>
            <Sparkles size={16} className="text-[#D4AF37] animate-pulse" data-id="element-154" />
          </div>
        </div>

        <div className="relative group/ribbon" data-id="element-155">
          <div className="flex overflow-hidden" data-id="element-156">
            <motion.div className="flex gap-10 py-8 px-4 pt-[0px] pb-[0px] mt-[0px] mb-[0px]" animate={{
            x: isBonusPaused ? undefined : [0, '-50%']
          }} transition={{
            duration: 400,
            repeat: Infinity,
            ease: 'linear'
          }} style={{
            display: 'flex',
            width: 'max-content'
          }} onClick={() => setIsBonusPaused(!isBonusPaused)} data-id="element-157">
              {/* Repeated many times for an indefinite, long ribbon feel */}
              {[...BONUSES, ...BONUSES, ...BONUSES, ...BONUSES, ...BONUSES, ...BONUSES, ...BONUSES, ...BONUSES, ...BONUSES, ...BONUSES].map((bonus, idx) => <div key={`${bonus.id}-${idx}`} className="w-[300px] md:w-[400px] flex-shrink-0 group cursor-pointer" data-id="element-158">
                  <div className="relative bg-white rounded-[3rem] p-6 border border-pink-50 shadow-sm group-hover:shadow-2xl group-hover:shadow-pink-100/40 transition-all duration-700 transform group-hover:-translate-y-3" data-id="element-159">
                    <div className="aspect-[4/5] overflow-hidden rounded-[2.5rem] bg-[#FDF2F2]/50 mb-8 flex items-center justify-center p-4" data-id="element-160">
                      <img src={bonus.img} alt={bonus.title} className="w-full h-full object-contain drop-shadow-2xl transform group-hover:scale-110 transition-transform duration-1000" data-id="element-161" />
                    </div>
                    <div className="px-2" data-id="element-162">
                      <div className="flex items-center gap-2 mb-4" data-id="element-163">
                        <div className="h-px flex-1 bg-pink-100" data-id="element-164" />
                        <span className="bg-[#D4AF37] text-white text-[9px] font-black px-3 py-1 rounded-full uppercase tracking-[0.2em]" data-id="element-165">
                          Bono #{bonus.id}
                        </span>
                        <div className="h-px flex-1 bg-pink-100" data-id="element-166" />
                      </div>
                      <h4 className="text-[#2D5A27] text-2xl font-serif font-bold mb-2 text-center" data-id="element-167">
                        {bonus.title}
                      </h4>
                      <p className="text-slate-500 text-xs text-center mb-4 leading-relaxed px-4" data-id="element-168">
                        {bonus.description}
                      </p>
                      <div className="flex flex-col items-center gap-1 bg-[#FDF2F2] p-4 rounded-2xl border border-pink-50" data-id="element-169">
                        <span className="text-[11px] text-slate-400 line-through font-medium" data-id="element-170">
                          VALOR REAL: $15.000 ARS
                        </span>
                        <span className="text-sm font-black text-[#9D4D60] tracking-widest uppercase" data-id="element-171">
                          ¡Hoy es tuyo GRATIS!
                        </span>
                      </div>
                    </div>
                  </div>
                </div>)}
            </motion.div>
          </div>
        </div>

        <div className="text-center mt-12 relative z-10" data-id="element-172">
          <motion.button onClick={() => setIsBonusPaused(!isBonusPaused)} className="inline-flex items-center gap-2 text-[#9D4D60] font-bold text-xs uppercase tracking-[0.3em] hover:text-[#D4AF37] transition-colors" animate={{
          opacity: [0.5, 1, 0.5]
        }} transition={{
          duration: 2,
          repeat: Infinity
        }} data-id="element-173">
            {isBonusPaused ? '▶ Continuar cinta' : '⏸ Pausar para ver detalle'}
          </motion.button>
        </div>
      </section>

      {/* Purchase Section */}
      <div ref={purchaseSectionRef} className="bg-[#FDF2F2] py-24 px-6 relative overflow-hidden pt-[30px] pb-[30px] mt-[0px] space-y-[33px]" data-id="element-174">
        {/* Decorative Background Elements */}
        <div className="absolute top-0 left-0 w-full h-full pointer-events-none overflow-hidden" data-id="element-175">
          <motion.div animate={{
          rotate: 360
        }} transition={{
          duration: 50,
          repeat: Infinity,
          ease: 'linear'
        }} className="absolute -top-24 -left-24 text-[#B76E79]/10" data-id="element-176">
            <Flower2 size={400} data-id="element-177" />
          </motion.div>
          <motion.div animate={{
          y: [0, 20, 0]
        }} transition={{
          duration: 8,
          repeat: Infinity,
          ease: 'easeInOut'
        }} className="absolute bottom-12 -right-12 text-[#2D5A27]/10" data-id="element-178">
            <Leaf size={300} data-id="element-179" />
          </motion.div>
        </div>

        <div className="max-w-3xl mx-auto relative z-10" data-id="element-180">
          {/* Pricing */}
          <div className="text-center space-y-8 mb-12" data-id="element-181">
            <div className="space-y-2" data-id="element-182">
              <p className="text-xl md:text-2xl line-through text-slate-400 font-serif italic" data-id="element-183">
                Antes $59.900 ARS
              </p>
              <div className="relative inline-block" data-id="element-184">
                <p className="text-7xl md:text-9xl font-serif font-bold tracking-tighter text-[#2D5A27] drop-shadow-sm" data-id="element-185">
                  $19.990<span className="text-3xl md:text-4xl ml-2" data-id="element-186">ARS</span>
                </p>
                <div className="absolute -top-4 -right-8 bg-[#D4AF37] text-white text-[10px] font-black px-3 py-1 rounded-full shadow-lg transform rotate-12 uppercase tracking-widest" data-id="element-187">
                  66% OFF
                </div>
              </div>
              <p className="text-xl md:text-2xl text-[#9D4D60] font-serif font-bold italic tracking-wide" data-id="element-188">
                Pago único • Acceso de por vida
              </p>
            </div>

            <div className="inline-flex items-center gap-3 bg-white/60 backdrop-blur-sm px-8 py-4 rounded-2xl border border-[#D4AF37]/20 shadow-sm pt-[0px] pb-[0px] pl-[18px] pr-[18px] mt-[14px] mb-[14px] ml-[6px] mr-[6px]" data-id="element-189">
              <div className="w-10 h-10 rounded-full bg-[#2D5A27]/5 flex items-center justify-center text-[#2D5A27]" data-id="element-190">
                <CreditCard size={20} data-id="element-191" />
              </div>
              <span className="font-bold text-[#2D5A27] tracking-tight" data-id="element-192">
                Hasta 3 cuotas sin interés
              </span>
            </div>

            {/* Ultra-compact Urgency Bar */}
            <div className="flex flex-row items-center justify-center gap-8 py-3 px-6 bg-white/40 rounded-full border border-[#D4AF37]/10 w-fit mx-auto pt-[12px] pb-[12px] mt-[16px] mb-[16px]" data-id="element-193">
              <div className="flex items-center gap-3" data-id="element-194">
                <div className="relative flex h-2 w-2" data-id="element-195">
                  <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-green-400 opacity-75" data-id="element-196"></span>
                  <span className="relative inline-flex rounded-full h-2 w-2 bg-green-500" data-id="element-197"></span>
                </div>
                <p className="text-[9px] md:text-[10px] font-black text-[#2D5A27] uppercase tracking-widest" data-id="element-198">
                  {viewers} MIRANDO
                </p>
              </div>
              <div className="w-px h-4 bg-[#D4AF37]/20" data-id="element-199" />
              <div className="flex items-center gap-3" data-id="element-200">
                <Ticket size={12} className="text-red-500" data-id="element-201" />
                <p className="text-[9px] md:text-[10px] font-black text-red-600 uppercase tracking-widest" data-id="element-202">
                  {coupons} CUPOS
                </p>
              </div>
            </div>
          </div>

          {/* Counter Block */}
          <div className="bg-white/40 backdrop-blur-sm rounded-3xl p-4 text-center border border-pink-100 shadow-inner max-w-sm mx-auto pt-[5px] pb-[5px] mt-[17px] mb-[17px]" data-id="element-203">
            <div className="flex items-center justify-center gap-2 mb-1" data-id="element-204">
              <Users size={16} className="text-[#D4AF37]" data-id="element-205" />
              <p className="text-3xl font-serif font-bold text-[#2D5A27]" data-id="element-206">
                {studentCount.toLocaleString('de-DE')}
              </p>
            </div>
            <p className="text-[9px] font-black uppercase tracking-[0.2em] text-[#9D4D60]" data-id="element-207">
              ALUMNAS YA ADQUIRIERON SU GUÍA
            </p>
          </div>

          {/* CTA Button */}
          <div className="relative group mb-10" data-id="element-208">
            <div className="absolute -inset-1 bg-gradient-to-r from-[#B76E79] via-[#D4AF37] to-[#9D4D60] rounded-2xl blur opacity-25 group-hover:opacity-50 transition duration-1000 group-hover:duration-200 animate-pulse" data-id="element-209"></div>
            <Button showShine className="relative bg-gradient-to-r from-[#B76E79] to-[#9D4D60] text-white text-xl md:text-2xl py-8 hover:shadow-[0_20px_50px_rgba(157,77,96,0.4)] border border-white/20 tracking-[0.1em]" data-id="element-210">
              SÍ, QUIERO MI GUIA AHORA{' '}
              <ArrowRight className="w-6 h-6 md:w-8 md:h-8 ml-2" data-id="element-211" />
            </Button>
          </div>

          {/* MercadoLíder Trust Section */}
          <div className="bg-white/80 backdrop-blur-sm border border-slate-100 rounded-2xl p-5 mb-10 shadow-sm max-w-md mx-auto text-left" data-id="element-212">
            <div className="flex items-center gap-3 mb-4" data-id="element-213">
              <div className="w-10 h-10 rounded-full bg-green-50 flex items-center justify-center text-green-600 shrink-0" data-id="element-214">
                <Medal size={20} data-id="element-215" />
              </div>
              <div data-id="element-216">
                <h4 className="text-green-600 font-bold text-sm leading-tight" data-id="element-217">
                  MercadoLíder Platinum
                </h4>
                <p className="text-slate-400 text-[10px] font-medium" data-id="element-218">
                  ¡Es uno de los mejores del sitio!
                </p>
              </div>
            </div>

            <div className="grid grid-cols-5 gap-1 mb-5" data-id="element-219">
              <div className="h-1 rounded-full bg-[#FFF1F1]" data-id="element-220" />
              <div className="h-1 rounded-full bg-[#FFF1F1]" data-id="element-221" />
              <div className="h-1 rounded-full bg-[#FFF1F1]" data-id="element-222" />
              <div className="h-1 rounded-full bg-green-200" data-id="element-223" />
              <div className="h-1 rounded-full bg-green-500" data-id="element-224" />
            </div>

            <div className="mb-5" data-id="element-225">
              <p className="text-xl font-bold text-slate-800" data-id="element-226">1010</p>
              <p className="text-[10px] text-slate-400 font-medium" data-id="element-227">
                Ventas en los últimos 60 días
              </p>
            </div>

            <div className="space-y-2.5 pt-4 border-t border-slate-50" data-id="element-228">
              <div className="flex items-center gap-3" data-id="element-229">
                <MessageCircle size={14} className="text-green-500" data-id="element-230" />
                <p className="text-[11px] font-medium text-slate-600" data-id="element-231">
                  Brinda buena atención
                </p>
              </div>
              <div className="flex items-center gap-3" data-id="element-232">
                <Zap size={14} className="text-green-500" data-id="element-233" />
                <p className="text-[11px] font-medium text-slate-600" data-id="element-234">
                  Despacha sus productos a tiempo
                </p>
              </div>
              <div className="flex items-center gap-3" data-id="element-235">
                <ShieldCheck size={14} className="text-[#D4AF37]" data-id="element-236" />
                <p className="text-[11px] font-bold text-slate-800" data-id="element-237">
                  Compra 100% Segura
                </p>
              </div>
            </div>
          </div>

          {/* Trust Badges */}
          <div className="grid grid-cols-1 md:grid-cols-2 gap-8 items-center justify-items-center mb-10 opacity-90" data-id="element-238">
            <img src="https://cdn.magicpatterns.com/uploads/2esg8TZ8XPcPzVZ7uhJqsN/pasted-image.png" alt="Compra Segura" className="h-14 md:h-16 object-contain" data-id="element-239" />
            <img src="https://cdn.magicpatterns.com/uploads/wokS51Pt6mAkbEbb1iBzyx/pasted-image.png" alt="Pago Seguro Garantizado" className="h-14 md:h-16 object-contain" data-id="element-240" />
          </div>
        </div>
      </div>

      {/* Testimonials & Comments */}
      <Section className="bg-white rounded-t-[3rem] -mt-12 relative z-10" data-id="element-241">
        <div className="text-center mb-12" data-id="element-242">
          <h3 className="text-3xl font-serif font-bold text-[#2D5A27] mb-2" data-id="element-243">
            Lo que dicen nuestras alumnas
          </h3>
          <div className="flex justify-center gap-1 text-[#D4AF37]" data-id="element-244">
            {[...Array(5)].map((_, i) => <Star key={i} fill="currentColor" data-id="element-245" />)}
          </div>
        </div>

        {/* Comment Input */}
        <div className="bg-[#FDF2F2] p-8 rounded-3xl mb-12 border border-pink-100" data-id="element-246">
          <h4 className="font-bold mb-4 text-lg" data-id="element-247">Dejá tu reseña</h4>
          <div className="flex gap-2 mb-4" data-id="element-248">
            {[1, 2, 3, 4, 5].map(star => <button key={star} onClick={() => setNewRating(star)} data-id="element-249">
                <Star className={`w-6 h-6 ${star <= newRating ? 'text-[#D4AF37] fill-[#D4AF37]' : 'text-slate-300'}`} data-id="element-250" />
              </button>)}
          </div>
          <textarea value={newComment} onChange={e => setNewComment(e.target.value)} placeholder="Escribí tu experiencia aquí..." className="w-full p-4 rounded-xl border border-slate-200 focus:ring-2 focus:ring-[#2D5A27] focus:border-transparent outline-none min-h-[120px] mb-4" data-id="element-251" />
          <button onClick={handlePostComment} className="bg-[#2D5A27] text-white px-8 py-3 rounded-xl font-bold hover:bg-[#1a3a18] transition-colors" data-id="element-252">
            Publicar
          </button>
        </div>

        {/* Comments List */}
        <div className="space-y-6" data-id="element-253">
          {comments.slice(0, visibleComments).map(comment => <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} key={comment.id} className="bg-white p-6 rounded-2xl border border-slate-100 shadow-sm" data-id="element-254">
              <div className="flex items-center gap-4 mb-4" data-id="element-255">
                {comment.avatar ? <img src={comment.avatar} alt={comment.name} className="w-12 h-12 rounded-full object-cover border-2 border-[#2D5A27]/10" data-id="element-256" /> : <div className="w-12 h-12 rounded-full bg-[#2D5A27]/10 flex items-center justify-center text-[#2D5A27] font-bold text-xl" data-id="element-257">
                    {comment.name[0]}
                  </div>}
                <div data-id="element-258">
                  <div className="flex items-center gap-2" data-id="element-259">
                    <p className="font-bold" data-id="element-260">{comment.name}</p>
                    <span className="text-xs text-slate-400" data-id="element-261">
                      • {comment.date}
                    </span>
                  </div>
                  <div className="flex gap-0.5" data-id="element-262">
                    {[...Array(5)].map((_, i) => <Star key={i} className={`w-3 h-3 ${i < comment.rating ? 'text-[#D4AF37] fill-[#D4AF37]' : 'text-slate-200'}`} data-id="element-263" />)}
                  </div>
                </div>
              </div>
              <p className="text-slate-600 leading-relaxed mb-4" data-id="element-264">
                {comment.text}
              </p>
              <button className="flex items-center gap-2 text-sm font-medium text-slate-400 hover:text-[#2D5A27] transition-colors" data-id="element-265">
                <ThumbsUp className="w-4 h-4" data-id="element-266" /> {comment.likes}
              </button>
            </motion.div>)}
        </div>

        {visibleComments < 30 && <div className="text-center mt-12" data-id="element-267">
            <button onClick={() => setVisibleComments(prev => Math.min(prev + 5, 35))} className="text-[#2D5A27] font-bold border-2 border-[#2D5A27] px-8 py-3 rounded-xl hover:bg-[#2D5A27] hover:text-white transition-all" data-id="element-268">
              Cargar 5 comentarios más
            </button>
          </div>}
      </Section>

      {/* Footer */}
      <footer className="text-white py-12 px-6 text-center bg-[#4D384D] pt-[41px] pb-[41px] mt-[47px] mb-[47px]" data-id="element-269">
        <p className="text-sm opacity-50 mb-4" data-id="element-270">
          © 2026 Cosmética Viva - Todos los derechos reservados
        </p>
        <p className="text-xs opacity-30 max-w-xl mx-auto" data-id="element-271">
          Este producto no sustituye el asesoramiento profesional. Siempre
          consulte a su médico o dermatólogo antes de aplicar nuevos productos
          en su piel.
        </p>
      </footer>

      {/* Modals & Notifications */}
      <AnimatePresence data-id="element-272">
        {purchaseNotify && <motion.div initial={{
        opacity: 0,
        x: -50
      }} animate={{
        opacity: 1,
        x: 0
      }} exit={{
        opacity: 0,
        x: -50
      }} className="fixed bottom-6 left-6 z-[100] bg-white/70 backdrop-blur-md p-3 rounded-2xl shadow-xl border border-white/40 flex items-center gap-3 max-w-[240px]" data-id="element-273">
            <div className="w-8 h-8 bg-[#FDF2F2] rounded-full flex items-center justify-center text-sm shadow-inner shrink-0" data-id="element-274">
              💄
            </div>
            <div className="min-w-0" data-id="element-275">
              <p className="text-[11px] font-bold text-[#9D4D60] leading-tight truncate" data-id="element-276">
                {purchaseNotify.name} de {purchaseNotify.city}
              </p>
              <p className="text-[10px] text-slate-500 leading-tight" data-id="element-277">
                Adquirió Cosmética Viva
              </p>
            </div>
          </motion.div>}

        {showSuccessModal && <div className="fixed inset-0 z-[200] flex items-center justify-center p-6 bg-black/60 backdrop-blur-sm" data-id="element-278">
            <motion.div initial={{
          scale: 0.9,
          opacity: 0
        }} animate={{
          scale: 1,
          opacity: 1
        }} className="bg-white p-8 rounded-[2rem] max-w-sm w-full text-center shadow-2xl" data-id="element-279">
              <div className="w-20 h-20 bg-green-100 text-green-600 rounded-full flex items-center justify-center mx-auto mb-6" data-id="element-280">
                <MessageCircle size={40} data-id="element-281" />
              </div>
              <h3 className="text-2xl font-bold mb-2" data-id="element-282">
                ¡Gracias por tu comentario!
              </h3>
              <p className="text-slate-600 mb-8" data-id="element-283">
                Tu opinión ayuda a la comunidad.
              </p>
              <button onClick={() => setShowSuccessModal(false)} className="w-full bg-[#2D5A27] text-white py-4 rounded-xl font-bold" data-id="element-284">
                Cerrar
              </button>
            </motion.div>
          </div>}
      </AnimatePresence>
    </div>;
}